(function () {
  var root = document.querySelector('[data-tc]');
  if (!root || root.__tc) return;
  root.__tc = true;
  function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

  /* sort */
  var sort = root.querySelector('[data-tc-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* mobile filter drawer */
  var side = root.querySelector('[data-tc-side]'), veil = root.querySelector('.tc-veil');
  function setOpen(on) {
    if (!side) return;
    side.classList.toggle('is-open', on);
    if (veil) veil.classList.toggle('is-open', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }
  $$('[data-tc-open]').forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
  $$('[data-tc-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });

  /* see more */
  $$('[data-tc-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var ul = b.previousElementSibling; var open = ul.classList.toggle('is-open');
      b.textContent = open ? 'See less' : 'See more';
    });
  });

  /* add to cart */
  var toast;
  function showToast(ok, title, msg) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'tc-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.classList.toggle('is-err', !ok);
    toast.innerHTML = '';
    var p = document.createElement('p'); p.textContent = ok ? '✓ Added to Cart' : 'Could not add to cart'; toast.appendChild(p);
    var s = document.createElement('small'); s.textContent = ok ? title : (msg || 'Please try again.'); toast.appendChild(s);
    if (ok) {
      var a = document.createElement('a'); a.href = '/checkout'; a.textContent = 'Proceed to Buy'; toast.appendChild(a);
      var c = document.createElement('a'); c.href = '/cart'; c.textContent = 'Go to Cart'; toast.appendChild(c);
    }
    toast.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 6000);
  }
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) {
        var t = el.querySelector('span:not(.visually-hidden)') || el; t.textContent = c.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c }));
    }).catch(function () {});
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tc-add]'); if (!b) return;
    e.preventDefault();
    b.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.tcAdd, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); return j; }); })
      .then(function () { showToast(true, b.dataset.title); refreshCount(); b.classList.add('is-done'); b.textContent = '✓ Added'; })
      .catch(function (err) { showToast(false, '', err.message); })
      .then(function () { b.classList.remove('is-busy'); });
  });

  /* browsing history (shared with product page) */
  try {
    var list = JSON.parse(localStorage.getItem('tp_rv') || '[]').filter(function (x) { return x && x.u; });
    var rv = root.querySelector('[data-tc-rv]');
    if (rv && list.length >= 2) {
      var tr = rv.querySelector('.tc-rv__track');
      list.slice(0, 16).forEach(function (x) {
        var a = document.createElement('a'); a.href = x.u;
        var sp = document.createElement('span'); var im = document.createElement('img'); im.loading = 'lazy'; im.alt = ''; im.src = x.i; sp.appendChild(im); a.appendChild(sp);
        var em = document.createElement('em'); em.textContent = x.t; a.appendChild(em);
        tr.appendChild(a);
      });
      rv.hidden = false;
    }
  } catch (e) {}
})();
